// @flow
'use strict'

/*::
import type RavenProxy from '../raven/ravenProxy'

import type { DatasetController } from './controller'

type Scope = {|
  componentId: string,
  itemId: string
|}

type ControllerMap = {
  [componentId: string]: {
    [itemId: string]: DatasetController
  }
}

export type ControllerStore = {|
  getAll: () => Array<DatasetController>,
  getController: (Scope) => DatasetController,
  removeController: (Scope) => void,
  setController: (Scope, controller: DatasetController) => void
|}
*/

const unset_ = require('lodash/unset')
const get_ = require('lodash/get')

const controllerStore = (
  ravenProxy /*: RavenProxy */
) /*: ControllerStore */ => {
  const scopesMap /*: ControllerMap */ = {}
  return {
    setController: (
      { componentId, itemId } /*: Scope */,
      controller /*: DatasetController */
    ) => {
      ravenProxy.captureBreadcrumb({
        level: 'info',
        category: 'scopeStore',
        message: 'adding scope',
        data: { componentId, itemId }
      })
      scopesMap[componentId] = scopesMap[componentId] || {}
      scopesMap[componentId][itemId] = controller
    },
    getController: ({ componentId, itemId } /*: Scope */) => {
      const componentScopes = scopesMap[componentId]
      return componentScopes && componentScopes[itemId]
    },
    removeController: ({ componentId, itemId } /*: Scope */) => {
      ravenProxy.captureBreadcrumb({
        level: 'info',
        category: 'scopeStore',
        message: 'removing scope',
        data: { componentId, itemId }
      })
      const componentScopes = scopesMap[componentId]
      if (get_(componentScopes, itemId)) {
        componentScopes[itemId].dispose()
        unset_(componentScopes, itemId)
      }
    },
    getAll: () /*: DatasetController[] */ => {
      return Object.values(scopesMap).reduce(
        (acc /*: any */, curr) => acc.concat(Object.values(curr)),
        []
      )
    }
  }
}

module.exports = controllerStore



// WEBPACK FOOTER //
// ./dataset-controller/controllerStore.js